<template class="full-heigth">
  <div class="full-heigth">
    <el-dialog
      @opened="getTaiwanCitiesOption(2, false)"
      @closed="onDialogClosed"
      :title="formData.id ? '編輯旅行社資料' : '新增旅行社資料'"
      :visible.sync="dialogFormVisible"
      top="2%"
    >
      <el-form ref="dynamicValidateForm" v-loading="formLoading" :model="formData">
        <el-form-item
          label="旅行社代碼"
          :label-width="formLabelWidth"
          prop="agencyCode"
          :rules="[{ required: true, message: '請輸入旅行社代碼', trigger: 'blur' }]"
        >
          <el-input v-model="formData.agencyCode" readonly autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="旅行社名稱"
          :label-width="formLabelWidth"
          prop="agencyName"
          :rules="[{ required: true, message: '請輸入旅行社名稱', trigger: 'blur' }]"
        >
          <el-input v-model="formData.agencyName" autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="旅行社簡稱"
          :label-width="formLabelWidth"
          prop="agencyShortName"
          :rules="[
            {
              required: true,
              message: '請輸入旅行社簡稱',
              trigger: 'change',
            },
          ]"
        >
          <el-input v-model="formData.agencyShortName" autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="統一編號"
          :label-width="formLabelWidth"
          prop="vatNumber"
          :rules="[{ required: true, message: '請輸入統一編號', trigger: 'blur' }]"
        >
          <el-input v-model="formData.vatNumber" autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="Mail"
          :label-width="formLabelWidth"
          prop="email"
          :rules="[
            {
              required: true,
              message: '請輸email',
              trigger: 'blur',
            },
            {
              required: true,
              pattern: pattern.email,
              message: 'mail格式不正確',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="formData.email" autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="地址"
          :label-width="formLabelWidth"
          prop="addr"
          :rules="[{ required: true, message: '請輸地址', trigger: 'blur' }]"
        >
          <el-row>
            <el-col :span="24" style="display: flex">
              <el-form-item>
                <input
                  :readonly="true"
                  type="text"
                  v-model="zipCode"
                  style="width: 70px; margin: 12px; color: red"
                />
              </el-form-item>
              <el-form-item
                prop="city"
                :rules="[
                  {
                    required: true,
                    message: '請選擇縣市',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  @change="getTaiwanCitiesOption(2, true)"
                  v-model="formData.city"
                  size="mini"
                  style="margin: 5px; width: 100%"
                  filterable
                  clearable
                  placeholder="請選擇縣市"
                >
                  <el-option
                    v-for="item in twCityOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                prop="site"
                :rules="[
                  {
                    required: true,
                    message: '請選擇行政區域',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  @change="getTaiwanCitiesOption(3, true)"
                  v-model="formData.site"
                  size="mini"
                  style="margin: 5px; width: 100%"
                  filterable
                  clearable
                  placeholder="請選擇行政區域"
                >
                  <el-option
                    v-for="item in twSiteOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                prop="road"
                :rules="[
                  {
                    required: true,
                    message: '請選擇路名',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                  @change="getTaiwanCitiesZipCode"
                  v-model="formData.road"
                  size="mini"
                  style="margin: 5px; width: 100%"
                  filterable
                  clearable
                  placeholder="請選擇路名"
                >
                  <el-option
                    v-for="item in twRoadOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-form-item>
              <el-input v-model="formData.addr" autocomplete="off" />
            </el-form-item>
          </el-row>
        </el-form-item>

        <el-form-item
          label="付款日"
          :label-width="formLabelWidth"
          prop="paymentDate"
          :rules="[
            {
              required: true,
              message: '請選擇付款日',
              trigger: 'change',
            },
          ]"
        >
          <el-select
            size="mini"
            style="margin: 5px; width: 50%"
            v-model="formData.paymentDate"
            filterable
            clearable
            placeholder="請選擇付款日"
          >
            <el-option v-for="item in checkOutDates" :key="item" :label="item" :value="item" />
          </el-select>
          日
        </el-form-item>

        <el-form-item
          label="結帳日"
          :label-width="formLabelWidth"
          prop="checkOutDate"
          :rules="[
            {
              required: true,
              message: '請選擇結帳日',
              trigger: 'change',
            },
          ]"
        >
          <el-select
            size="mini"
            style="margin: 5px; width: 50%"
            v-model="formData.checkOutDate"
            filterable
            clearable
            placeholder="請選擇結帳日"
          >
            <el-option v-for="item in checkOutDates" :key="item" :label="item" :value="item" />
          </el-select>
          日
        </el-form-item>

        <el-form-item
          label="電話"
          :label-width="formLabelWidth"
          prop="tel"
          :rules="[{ required: true, message: '請輸入電話', trigger: 'blur' }]"
        >
          <el-input v-model="formData.tel" autocomplete="off" />
        </el-form-item>

        <el-form-item
          label="負責人"
          :label-width="formLabelWidth"
          prop="boss"
          :rules="[{ required: true, message: '請輸負責人', trigger: 'blur' }]"
        >
          <el-input v-model="formData.boss" autocomplete="off" />
        </el-form-item>

        <el-form-item label="代表圖" :label-width="formLabelWidth">
          <div>
            <Upload
              ref="uploadRef"
              :payload="formData"
              :accept="'.jpg,.jpeg,.png'"
              :limitText="'請上傳正方形圖片以利APP呈現，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
              :data-obj="fileObj"
              :use-drag="false"
              :action="'Agency/saveAgency'"
              :auto-upload="false"
              :show-file-list="true"
              :form-on-loading-parent="formOnLoading"
              :btn-txt="'上傳'"
              :before-file-list="
                formData.fileInfo && formData.fileInfo.length ? formData.fileInfo[0].files : []
              "
            />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="領隊資料維護" :visible.sync="dialogLeaderFormVisible">
      <div>
        <leader-data :agency-code="leaderAgecnyCode" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogLeaderFormVisible = false">關 閉</el-button>
      </div>
    </el-dialog>

    <el-dialog title="試用設定" :visible.sync="dialogFreeDateFormVisible">
      <el-form :inline="true">
        <el-form-item label="試用區間">
          <el-date-picker
            v-model="freeDateForm.freeDate"
            type="daterange"
            align="right"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFreeDateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAgencyFreeDate">儲 存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="`【${promotionalPlanForm.agencyName}】折抵金額人數設定`"
      :visible.sync="dialogPromotionalPlanFormVisible"
      @closed="handleClosedPromotionalPlanFormDialog"
    >
      <el-form
        ref="selectedPromotionalPlanFormRef"
        :model="promotionalPlanForm"
        @submit.native.prevent
        label-width="80px"
        label-position="right"
        :rules="promotionalPlanFormRules"
      >
        <el-form-item label="使用方案" prop="plan">
          <el-select
            v-model="promotionalPlanForm.plan"
            value-key="id"
            class="w-full-select"
            placeholder="請選擇方案"
            filterable
            default-first-option
            @change="handlePromotionalPlanChange"
          >
            <el-option
              v-for="promotionalPlan in promotionalPlanOptions"
              :key="promotionalPlan.id"
              :value="promotionalPlan"
              :label="promotionalPlan.name"
            >
              <span style="float: left">{{ promotionalPlan.name }}</span>
              <span
                style="float: right; color: #8492a6; font-size: 13px"
                v-show="promotionalPlan.startDate"
                >{{ promotionalPlan.startDate }}~{{ promotionalPlan.endDate }}</span
              >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用日期" prop="date" v-if="!!promotionalPlanForm.plan">
          <el-date-picker
            class="w-full-date"
            v-model="promotionalPlanForm.date"
            type="daterange"
            align="right"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            value-format="yyyy-MM-dd"
            :disabled="!!promotionalPlanForm.plan.startDate && !!promotionalPlanForm.plan.endDate"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPromotionalPlanFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAgencyPromotionalPlan">儲 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="AI設定" :visible.sync="dialogAISettingVisible">
      <el-form :inline="true">
        <el-form-item
          label="APP AI"
          :label-width="formLabelWidth"
          prop="appAIUrl"
          :rules="[{ required: false, message: '請輸入APP AI URL', trigger: 'blur' }]"
        >
          <el-input v-model="aiDataForm.appAIUrl" autocomplete="off" style="width: 300px" />
        </el-form-item>

        <el-form-item
          label="WEB AI"
          :label-width="formLabelWidth"
          prop="webAIUrl"
          :rules="[{ required: false, message: '請輸入WEB AI URL', trigger: 'blur' }]"
        >
          <el-input v-model="aiDataForm.webAIUrl" autocomplete="off" style="width: 300px" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAISettingVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAISetting">儲 存</el-button>
      </div>
    </el-dialog>

    <el-form :inline="true" class="demo-form-inline" @submit.native.prevent>
      <el-form-item label="代碼查詢">
        <el-input v-model="listQuery.qry" placeholder="輸入代碼" @keyup.enter.native="getList" />
      </el-form-item>

      <!-- <el-form-item label="名稱查詢">
        <el-select placeholder="輸入名稱">
          <el-option label="区域一" value="shanghai" />
          <el-option label="区域二" value="beijing" />
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="getList">查詢</el-button>
        <el-button type="success" @click="addData">建立</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          style="cursor: pointer"
          :loading="listLoading"
          type="success"
          icon="el-icon-refresh-left"
          circle
          @click="refresh()"
        ></el-button>
      </el-form-item>
    </el-form>
    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        :data="list"
        size="mini"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="ID" width="40">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="代碼" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.agencyCode }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="名稱" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.agencyName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="統編" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.vatNumber }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="電話" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.tel }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="負責人" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.boss }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" label="領隊管理" width="120">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editLeaderInfoData(scope.row)"
              >領隊維護</el-button
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="試用設定" width="180">
          <template slot-scope="scope">
            <div>
              <div
                v-show="scope.row.freeDateInfo.freeStartDate && scope.row.freeDateInfo.freeEndDate"
              >
                <el-tooltip placement="top" v-show="scope.row.freeDateInfo.isFree">
                  <div slot="content">剩餘試用天數：{{ scope.row.freeDateInfo.diffDays }}</div>
                  <span style="cursor: default; color: red">
                    {{ scope.row.freeDateInfo.freeStartDate }} 至
                    {{ scope.row.freeDateInfo.freeEndDate }}
                  </span>
                </el-tooltip>
                <span v-show="!scope.row.freeDateInfo.isFree" style="cursor: default">
                  {{ scope.row.freeDateInfo.freeStartDate }} 至
                  {{ scope.row.freeDateInfo.freeEndDate }}
                </span>
              </div>
              <el-button type="primary" size="mini" @click="editAgencyFreeDate(scope.row)"
                >設定</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="折抵金額人數" width="400">
          <template slot-scope="scope">
            <div
              v-if="scope.row.promotionalPlan"
              style="
                display: flex;
                flex-direction: column;
                gap: 6px 0;
                justify-content: center;
                align-items: center;
                width: 100%;
              "
            >
              <div
                v-for="promotionalPlanItem in scope.row.promotionalPlan"
                :key="promotionalPlanItem.planId"
                style="width: 100%"
              >
                <div
                  style="
                    display: flex;
                    gap: 0 8px;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="text-align: left">
                    {{ promotionalPlanItem.name }}
                    <!-- 金額折抵 -->
                    <span v-if="promotionalPlanItem.initBalance">
                      <span style="color: red">
                        {{ promotionalPlanItem.initBalance.toLocaleString() }}元
                      </span>
                      <span style="color: #959595" v-if="promotionalPlanItem.availableBalance">
                        ({{ promotionalPlanItem.availableBalance.toLocaleString() }})
                      </span>
                    </span>
                    <!-- 人數折抵 -->
                    <span v-if="promotionalPlanItem.initHeadCount">
                      <span style="color: red">
                        {{ promotionalPlanItem.initHeadCount.toLocaleString() }}人
                      </span>
                      <span style="color: #959595" v-if="promotionalPlanItem.remainingHeadCount">
                        ({{ promotionalPlanItem.remainingHeadCount.toLocaleString() }})
                      </span>
                    </span>
                    {{ promotionalPlanItem.startDate }} 至 {{ promotionalPlanItem.endDate }}
                  </div>
                  <el-button
                    v-show="
                      (promotionalPlanItem.initBalance &&
                        promotionalPlanItem.initBalance === promotionalPlanItem.availableBalance) ||
                      (promotionalPlanItem.initHeadCount &&
                        promotionalPlanItem.initHeadCount ===
                          promotionalPlanItem.remainingHeadCount)
                    "
                    type="danger"
                    size="mini"
                    @click="handleDeleteAgencyPromotionalPlan(promotionalPlanItem)"
                    >刪除</el-button
                  >
                </div>
              </div>
            </div>
            <el-button
              v-if="
                !scope.row.promotionalPlan ||
                (scope.row.promotionalPlan && scope.row.promotionalPlan.length === 0)
              "
              type="primary"
              size="mini"
              @click="editAgencyPromotionalPlan(scope.row)"
              >設定</el-button
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="AI設定" width="180">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="editAISetting(scope.row)"
                >設定</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="語音翻譯功能" width="120">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isVoiceTranslation"
              active-text="開"
              inactive-text="關"
              @change="handleSwitchChange(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      style="padding-top: 0; margin-top: 15px"
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import {
  getAgencyList,
  saveAgency,
  getAgencySerialNumber,
  getTaiwanCitiesZipCode,
  getTaiwanCitiesOption,
  getAgencyFreeDate,
  setAgencyFreeDate,
  setAgencyPromotionalPlan,
  deleteAgencyPromotionalPlan,
  savaAISetting,
  savaVoiceTranslation,
} from '@/api/agency'
import { getPromotionalPlans } from '@/api/promotionalPlan'
import { MessageBox, Message } from 'element-ui'
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数

var defaultForm = {
  id: null,
  fileInfo: {},
  checkOutDate: null,
  paymentDate: null,
}

export default {
  name: 'AgencyTable',
  components: {
    leaderData: () => import('@/views/ita/components/leaderData.vue'),
    Pagination,
    Upload,
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      pattern: {
        email:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      },
      twCityOptions: [],
      twSiteOptions: [],
      twRoadOptions: [],
      zipCode: null,
      checkOutDates: [],
      formOnLoading: false,
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      leaderAgecnyCode: '',
      isAdd: true,
      formLabelWidth: '120px',
      formData: defaultForm,
      leaderFormData: { id: null },
      dialogFormVisible: false,
      dialogAISettingVisible: false,
      dialogLeaderFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      dialogFreeDateFormVisible: false,
      freeDateForm: {
        agencyCode: '',
        freeDate: [],
      },
      aiDataForm: {
        agencyCode: '',
        appAIUrl: '',
        webAIUrl: '',
      },
      dialogPromotionalPlanFormVisible: false,
      promotionalPlanOptions: [],
      promotionalPlanForm: {
        agencyName: '',
        agencyCode: '',
        date: [],
        plan: null,
      },
      promotionalPlanFormRules: {
        plan: [{ required: true, message: '請選擇方案', trigger: 'blur' }],
        date: [{ required: true, message: '請選擇使用日期', trigger: 'blur' }],
      },
      pickerPromotionalPlanDateOptions: {
        disabledDate: time => {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          return time.getTime() <= today.getTime()
        },
      },
    }
  },
  async created() {
    await this.getTaiwanCitiesOption(1, true)
    // if (this.userInfo.agencyCode) {
    //   alert(5);
    //   await this.getAnAgencyByCode();
    //   await this.getTaiwanCitiesOption(2, false);
    // }

    for (let i = 1; i <= 31; i++) {
      this.checkOutDates.push(i)
    }
    await this.getList()
  },
  methods: {
    checkPermission,
    async refresh() {
      this.defaultListyQuerySetting()
      await this.getList()
    },
    async getTaiwanCitiesZipCode() {
      let resp = await getTaiwanCitiesZipCode({
        city: this.formData.city,
        site: this.formData.site,
        road: this.formData.road,
      })
      this.zipCode = resp.data
    },
    async getTaiwanCitiesOption(filterType, bindDefault) {
      try {
        let resp
        switch (filterType) {
          case 1:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: null,
              site: null,
            })
            this.twCityOptions = resp.data
            if (bindDefault) {
              this.formData.city = this.twCityOptions[0]
            }

            break
          case 2:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: this.formData.city,
              site: null,
            })
            this.twSiteOptions = resp.data
            if (bindDefault) {
              this.formData.site = this.twSiteOptions[0]
            }
            this.getTaiwanCitiesOption(3, bindDefault)

            break
          case 3:
            resp = await getTaiwanCitiesOption({
              filterType,
              city: this.formData.city,
              site: this.formData.site,
            })
            this.twRoadOptions = resp.data
            if (bindDefault) {
              this.formData.road = this.twRoadOptions[0]
            }
            await this.getTaiwanCitiesZipCode()

            break
          default:
            break
        }
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    defaultListyQuerySetting() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },
    async addData() {
      const vm = this
      vm.isAdd = true
      let serialNumber = await vm.getAgencySerialNumber()
      vm.formData = defaultForm
      vm.formData.agencyCode = serialNumber
      vm.dialogFormVisible = true
    },
    async getAgencySerialNumber() {
      let resp = await getAgencySerialNumber()
      return resp.data
    },
    async saveData(formName) {
      const vm = this
      if (!vm.isAdd && !confirm(`確定要儲存${vm.formData.agencyName}資料?`)) {
        return false
      }
      //$refs["uploadRef"] 不能放在 $refs[formName]的敘述裡面建立，組件裡面會找不到refs.upload
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.formLoading = true
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          await saveAgency(payload).then(response => {
            refUpload.clearFiles()
            vm.dialogFormVisible = false
            vm.formLoading = false
            vm.getList()
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      await getAgencyList(this.listQuery).then(response => {
        this.listLoading = false
        this.list = response.data.data
        this.total = response.data.total
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
    },
    editData(d) {
      const vm = this
      vm.isAdd = false
      vm.formData = d
      vm.dialogFormVisible = true
    },
    editLeaderInfoData(d) {
      const vm = this
      vm.dialogLeaderFormVisible = true
      vm.leaderAgecnyCode = d.agencyCode
    },
    async editAgencyFreeDate(agency) {
      const vm = this
      const params = {
        agencyCode: agency.agencyCode,
      }
      await getAgencyFreeDate(params)
        .then(response => {
          vm.freeDateForm.agencyCode = response.data.agencyCode
          vm.freeDateForm.freeDate = [response.data.freeStartDate, response.data.freeEndDate]
          vm.dialogFreeDateFormVisible = true
        })
        .catch(err => {
          console.log(err)
        })
      console.log(agency)
    },
    async saveAgencyFreeDate() {
      const vm = this
      const freeStartDate = vm.freeDateForm.freeDate[0]
      const freeEndDate = vm.freeDateForm.freeDate[1]
      const params = {
        agencyCode: vm.freeDateForm.agencyCode,
        freeStartDate: freeStartDate,
        freeEndDate: freeEndDate,
      }
      await setAgencyFreeDate(params)
        .then(response => {
          vm.dialogFreeDateFormVisible = false
          vm.getList()
          Message({
            message: '試用設定完成',
            type: 'success',
            duration: 5 * 1000,
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    editAISetting(agency) {
      const vm = this
      vm.dialogAISettingVisible = true
      vm.aiDataForm.agencyCode = agency.agencyCode
      vm.aiDataForm.appAIUrl = agency.appAIUrl
      vm.aiDataForm.webAIUrl = agency.webAIUrl
    },
    // 儲存AI設定
    async saveAISetting() {
      const vm = this
      const params = {
        agencyCode: vm.aiDataForm.agencyCode,
        appAIUrl: vm.aiDataForm.appAIUrl,
        webAIUrl: vm.aiDataForm.webAIUrl,
      }
      console.log('儲存AI設定', params)
      await savaAISetting(params)
        .then(response => {
          vm.dialogAISettingVisible = false
          vm.getList()
          Message({
            message: 'AI設定完成',
            type: 'success',
            duration: 5 * 1000,
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    async handleSwitchChange(row) {
      console.log(`切換狀態: ${row.isVoiceTranslation ? '啟用' : '停用'}`, row)
      const vm = this

      const confirmed = window.confirm(
        `是否${row.isVoiceTranslation ? '開啟' : '關閉'}語音翻譯功能？`
      )
      if (!confirmed) {
        return // 使用者取消，不繼續送出
      }

      const params = {
        agencyCode: row.agencyCode,
        isVoiceTranslation: row.isVoiceTranslation,
      }
      console.log('儲存語音翻譯功能設定', params)
      await savaVoiceTranslation(params)
        .then(response => {
          vm.getList()
          Message({
            message: '設定完成',
            type: 'success',
            duration: 5 * 1000,
          })
        })
        .catch(err => {
          console.log(err)
        })

      // 在這裡可以呼叫 API 更新狀態
      // 例如：
      // updateAgencyStatus({ id: row.id, isEnabled: row.isEnabled })
      //   .then(() => {
      //     this.$message.success('狀態更新成功');
      //   })
      //   .catch(err => {
      //     console.error(err);
      //     this.$message.error('狀態更新失敗');
      //   });
    },
    // 設定折抵金額人數
    async editAgencyPromotionalPlan(agency) {
      const vm = this
      this.listLoading = true
      const query = {
        qry: '',
        date: '',
        status: 1,
        page: 1,
        limit: 1000,
      }
      getPromotionalPlans(query)
        .then(response => {
          this.promotionalPlanOptions = response.data.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
      this.promotionalPlanForm.agencyName = agency.agencyName
      this.promotionalPlanForm.agencyId = agency.id
      vm.dialogPromotionalPlanFormVisible = true
    },
    handleClosedPromotionalPlanFormDialog() {
      this.$nextTick(() => {
        this.$refs.selectedPromotionalPlanFormRef.clearValidate()
        this.$refs.selectedPromotionalPlanFormRef.resetFields()
      })
    },
    // 設定折抵金額人數
    async saveAgencyPromotionalPlan() {
      const vm = this
      this.$refs.selectedPromotionalPlanFormRef.validate(valid => {
        if (!valid) return
        const startDate = vm.promotionalPlanForm.date[0]
        const endDate = vm.promotionalPlanForm.date[1]
        const params = {
          agencyId: vm.promotionalPlanForm.agencyId,
          planId: vm.promotionalPlanForm.plan.id,
          startDate: startDate,
          endDate: endDate,
        }
        console.log(params)
        vm.listLoading = true
        setAgencyPromotionalPlan(params)
          .then(async res => {
            Message({
              message: '資料處理完成',
              type: 'success',
              duration: 5 * 1000,
            })
            vm.dialogPromotionalPlanFormVisible = false
            await vm.getList()
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            vm.listLoading = false
          })
      })
    },
    // 設定折抵金額人數
    handlePromotionalPlanChange(val) {
      if (!!val.startDate && !!val.endDate) {
        this.promotionalPlanForm.date = [val.startDate, val.endDate]
      } else {
        this.promotionalPlanForm.date = null
      }
    },
    // 刪除設定折抵金額人數
    handleDeleteAgencyPromotionalPlan(promotionalPlan) {
      let vm = this
      if (confirm(`確定刪除【${promotionalPlan.name}】方案?`)) {
        vm.listLoading = true
        deleteAgencyPromotionalPlan({ id: promotionalPlan.id })
          .then(async res => {
            await vm.getList()
            vm.$message({
              message: '資料處理完成',
              type: 'success',
            })
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            vm.listLoading = false
          })
      }
    },
  },
}
</script>
<style>
.full-heigth {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped>
.isFree {
  color: red;
}
</style>
